import { withStyles } from '@material-ui/core/styles';
import Appearance from 'styles/Appearance.js';
import LinearProgress from '@material-ui/core/LinearProgress';

const ProgressBar = withStyles({
    colorPrimary: {
        backgroundColor: Appearance.colors.primary(),
    },
    barColorPrimary: {
        backgroundColor: Appearance.colors.soft()
    }
})(LinearProgress);

export default ProgressBar;
